// extracted by mini-css-extract-plugin
export var chatHtmlText = "_rk-2";
export var chatLink = "_rk-0";
export var chatText = "_rk-1";